function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React from 'react';
import styled, { css } from '../styled-components';
import CheckIcon from '../icons/Check';
var StyledCheckbox =
/*#__PURE__*/
styled.label.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-14mxauu-0"
})(["display:block;width:20px;height:20px;border:1px solid #ededed;", " display:flex;align-items:center;justify-content:center;border-radius:3px;background-color:#ffffff;cursor:pointer;color:#ffffff;&:focus-within,&:hover{border-color:", ";}&[data-checked='mixed'],&[data-checked='true']{background-color:", ";}&[data-disabled='true']{background-color:#f4f4f4;border-color:#ededed;cursor:default;}"], function (props) {
  return props.size === 'small' && css(["width:16px;height:16px;"]);
}, function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.primary.lightBlue;
});
var StyledInput =
/*#__PURE__*/
styled.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "sc-14mxauu-1"
})(["position:absolute;opacity:0;height:0;width:0;"]);
var MixedIcon =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Checkbox__MixedIcon",
  componentId: "sc-14mxauu-2"
})(["width:10px;height:2px;border-radius:1px;background-color:#ffffff;"]);

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Checkbox, [{
    key: "onChange",
    value: function onChange() {
      if (this.props.value === 'mixed' || this.props.value === true) {
        this.props.onChange(false);
      } else {
        this.props.onChange(true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var ariaChecked = this.props.value === true ? 'true' : this.props.value === false ? 'false' : this.props.value;
      var checked = this.props.value === 'mixed' ? false : this.props.value;
      return React.createElement(StyledCheckbox, {
        className: this.props.className,
        "data-checked": ariaChecked,
        "data-disabled": this.props.disabled,
        size: this.props.size ? this.props.size : 'normal'
      }, React.createElement(StyledInput, {
        id: this.props.id,
        type: "checkbox",
        "aria-checked": ariaChecked,
        disabled: this.props.disabled,
        checked: checked,
        onChange: this.onChange
      }), this.props.value === true && React.createElement(CheckIcon, {
        width: this.props.size === 'small' ? 10 : 14
      }), this.props.value === 'mixed' && React.createElement(MixedIcon, null));
    }
  }]);

  return Checkbox;
}(React.Component);

export { Checkbox as default };